module.exports = __webpack_public_path__ + "static/geigen-6eb863e2dddfa53cd0165bf69298ef1d.jpg";